// Module
var code = "<div class=\"SubmitClaimPage\"> <h4 class=\"SubmitClaimPage__header SubmitClaimUploading__header\"> Please wait while we upload your attachments and submit your claim. </h4> <div class=\"SubmitClaimUploading__logoContainer\"> <ch-spinner class=\"SubmitClaimUploading__logo\"></ch-spinner> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/activity/submitClaim/pages/submitClaimUploading/submitClaimUploading.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;